import { ComponentType, lazy } from "react";

// One automatic reload per tab session, shared across routes/builds. Keeping the
// marker prevents loops if a reload still receives an outdated HTML document.
const RELOAD_KEY = "forsler:chunk-recovery-reloaded";

export async function importWithRecovery<T>(
  load: () => Promise<T>,
  reload = () => window.location.reload(),
): Promise<T> {
  try {
    return await load();
  } catch (error) {
    if (error instanceof Error && error.name === "ChunkLoadError") {
      let shouldReload = false;
      try {
        if (!sessionStorage.getItem(RELOAD_KEY)) {
          sessionStorage.setItem(RELOAD_KEY, "1");
          shouldReload = true;
        }
      } catch {
        // Without durable storage we cannot safely prevent a reload loop.
      }
      if (shouldReload) {
        reload();
        return new Promise<T>(() => {});
      }
    }
    // Existing error boundary supplies the translated manual reload button.
    throw error;
  }
}

export function lazyWithRecovery<T extends ComponentType<any>>(
  load: () => Promise<{ default: T }>,
) {
  return lazy(() => importWithRecovery(load));
}
